var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard-layout"}},[_c('Header'),_vm._t("default"),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }